import { ResourceType } from '../../constants'
import { Appointment } from '../../types'
import { isPooledSchedulingInScope } from '../isPooledSchedulingInScope'

type AppointmentFields = Pick<Appointment, 'country' | 'journey' | 'resources' | 'type'>

const providerTypes = new Set<string>([ResourceType.FITTER, ResourceType.FITTER_INTERNAL])

const isAwaitingProviderMatching = ({ country, journey, resources, type }: AppointmentFields): boolean =>
  isPooledSchedulingInScope({ appointmentType: type.appointment_type, country, journey }) &&
  !(resources ?? []).some(({ type: resourceType }) => providerTypes.has(resourceType))

export { isAwaitingProviderMatching }
